import { eAtlas, Game } from "../../Game";
import { AtlasAnimClip, AtlasAnimClipData } from "../../Utils/Atlas/AtlasAnimClip";
import { Pool } from "../../Utils/Collections/Pool";
import { WrappedArray } from "../../Utils/Collections/WrapperArray";
import { CircleFx, CircleFxSettings } from "../CircleFx";
import { TIMER } from "../Gameplay";
import { RoundManager } from "../Round/RoundManager";
import { Ball } from "./Ball";







export class BallKickOffMark {
    private _ball: Ball;
    private _container: pc.GraphNode;
    private _circleFx: CircleFx;
    private _innerCircleEnt: pc.Entity;
    private _fireBallFxEnt: pc.Entity;
    private _fireBallFxAnimClip: AtlasAnimClip;
    private _fireBallFxAnimClipData: AtlasAnimClipData;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(ball: Ball) {
        this._ball = ball;

        this._container = new pc.GraphNode();
        Game.app.root.addChild(this._container);

        this._circleFx = new CircleFx(new CircleFxSettings({
            innerRadius: 0.4,
            innerGradientSize: 0.04,
            outerGradientSize: 0.04,
            color: new pc.Color(1, 1, 1),
        }, {
            duration: 1000,
            scaleFrom: 0.4,
            scaleTo: 1,
            scaleEase: pc.SineOut,
            opacityFrom: 0.5,
            opacityTo: 0,
            opacityEase: pc.SineIn
        }, 600, 1, this._container, undefined, undefined, undefined, undefined, true));

        // Vnitrni kruh (pouzije material pro efekt)
        this._innerCircleEnt = new pc.Entity();
        this._innerCircleEnt.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.plane,
            castShadows: false,
            castShadowsLightmap: false,
            receiveShadows: true,
            material: CircleFx.material,
        });
        this._innerCircleEnt.setLocalScale(0.4, 0.4, 0.4);

        let mesh = this._innerCircleEnt.model.meshInstances[0];

        mesh.setParameter("material_opacity", 0.75);
        mesh.setParameter("uInnerRadius", 0.325);
        mesh.setParameter("uInnerGradientSize", 0.05);
        mesh.setParameter("uOuterGradientSize", 0.05);

        this._container.addChild(this._innerCircleEnt);

        // Animovany efekt pro fireball
        this._fireBallFxEnt = new pc.Entity();
        this._fireBallFxEnt.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: new pc.Vec4(0.5, 0.5, 0.5, 0.5),
            pivot: new pc.Vec2(0.5, 0.5),
            width: 0.75,
            height: 0.75,
            texture: Game.getAtlas(eAtlas.fx1).texture
        });
        this._fireBallFxEnt.setEulerAngles(-90, 0, 0);
        this._fireBallFxEnt.enabled = false;
        this._container.addChild(this._fireBallFxEnt);

        this._fireBallFxAnimClip = new AtlasAnimClip(TIMER);
        this._fireBallFxAnimClipData = new AtlasAnimClipData(Game.getAtlas(eAtlas.fx1), "1/", 25, 0, 14, -1);

        this._fireBallFxAnimClip.play(this._fireBallFxAnimClipData);
        this._fireBallFxEnt.element.rect = this._fireBallFxAnimClip.curFrameRect;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(): void {
        // Pozice
        let pos = RoundManager.instance.roundSetup.kickOffPos;

        this._container.setPosition(pos.x, pos.y - Ball.RADIUS + 0.001, pos.z);

        if (this._ball.fireBallState == 1) {
            if (!this._fireBallFxEnt.enabled) {
                this._fireBallFxAnimClip.play(this._fireBallFxAnimClipData);
                this._fireBallFxEnt.element.rect = this._fireBallFxAnimClip.curFrameRect;
                this._fireBallFxEnt.enabled = true;

                this._circleFx.reset();
                this._innerCircleEnt.enabled = false;
            }
        }
        else {
            if (this._fireBallFxEnt.enabled) {
                this._fireBallFxEnt.enabled = false;
                this._fireBallFxAnimClip.reset();

                this._innerCircleEnt.enabled = true;
            }

            if (!this._circleFx.isActive)
                this._circleFx.start();
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        if (this._fireBallFxEnt.enabled) {
            if (this._fireBallFxAnimClip.update())
                this._fireBallFxEnt.element.rect = this._fireBallFxAnimClip.curFrameRect;
        }
        else {
            this._circleFx.update();
        }
    }
}